import { inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoFlowStateService } from '../video-flow-state.service';
import { EmailValidationData } from '../../../../../../../models/order/workflow/video/email-validation.model';

@Injectable({ providedIn: 'root' })
export class EmailValidationStateService extends BaseWorkflowStateService<EmailValidationData> {
    private flowStateService = inject(VideoFlowStateService);
    override stateKey: string = 'emailValidation';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
